import { Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#050505] py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img
            src="/bellso-logo.png"
            alt="bellso — premium web design studio"
            className="h-28 w-auto rounded-full"
          />
          <p className="mt-4 text-zinc-400 max-w-md">
            High-end, lead-optimized websites — designed, built, and maintained
            by a small team that actually cares.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="font-mono-jb text-xs uppercase tracking-widest text-[#CCFF00] mb-4">
            / Navigate
          </div>
          <ul className="space-y-2 text-zinc-400">
            <li><a href="#services" className="hover:text-[#CCFF00]">Services</a></li>
            <li><a href="#portfolio" className="hover:text-[#CCFF00]">Portfolio</a></li>
            <li><a href="#pricing" className="hover:text-[#CCFF00]">Pricing</a></li>
            <li><a href="#faq" className="hover:text-[#CCFF00]">FAQ</a></li>
            <li><a href="/admin" className="hover:text-[#CCFF00]">Admin</a></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="font-mono-jb text-xs uppercase tracking-widest text-[#CCFF00] mb-4">
            / Contact
          </div>
          <ul className="space-y-3 text-zinc-400">
            <li className="flex items-center gap-2">
              <Mail className="w-4 h-4 text-[#CCFF00]" />
              info@bellsodigital.com
            </li>
            <li className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-[#CCFF00]" />
              Remote · Serving US & Canada
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 mt-12 pt-8 border-t border-white/5 flex justify-between items-center text-xs text-zinc-500 font-mono-jb">
        <span>© {new Date().getFullYear()} bellso digital. All rights reserved.</span>
        <span>Built with ✦ love.</span>
      </div>
    </footer>
  );
}
